// extracted by mini-css-extract-plugin
export default {"collaborator":"tpL+P"};